export default __webpack_public_path__ + "static/media/compose_logo_half.23d0b74f.svg";